import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';

export const getLastWinTranslationKey = () =>
    partnerSettingsStore.isUnitedKingdomMarket ? 'last_return' : 'last_win';
